import gsap from 'gsap'

export default class CopyLink {
  constructor() {
    this._getElems()
    this._events()
  }

  _getElems() {
    this.copyLink = {
      el: document.querySelector('.share-copy'),
      textCopy: document.querySelector('.share-copy .copy'),
      textCopied: document.querySelector('.share-copy .copied')
    }
  }

  _events() {
    if (this.copyLink.el) {
      gsap.set(this.copyLink.textCopied, {
        yPercent: 100
      })

      this.copyLink.el.addEventListener('click', () => {
        const tl = gsap.timeline()
          .to(this.copyLink.textCopy, {
            yPercent: -100,
            duration: 0.2,
            ease: 'power3.out'
          })
          .to(this.copyLink.textCopied, {
            yPercent: 0,
            duration: 0.2,
            ease: 'power3.out'
          }, '<')
          .set(this.copyLink.textCopy, {
            yPercent: 100
          })
          .to(this.copyLink.textCopied, {
            yPercent: -100,
            duration: 0.2,
            ease: 'power3.out',
            delay: 0.8
          })
          .to(this.copyLink.textCopy, {
            yPercent: 0,
            duration: 0.2,
            ease: 'power3.out'
          }, '<')
          .set(this.copyLink.textCopied, {
            yPercent: 100
        })

        tl.play()
        navigator.clipboard.writeText(window.location.href)
      })
    }
  }
}
